import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Impressum from '../components/impressum'
import Footer from '../components/footer'
import './impressum-page.css'

const ImpressumPage = (props) => {
  return (
    <div className="impressum-page-container">
      <Helmet>
        <title>
          Impressum - Stefan Lacher | Software Solutions for Web, Apps & Data
        </title>
        <meta
          name="description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:title"
          content="Impressum - Stefan Lacher | Software Solutions for Web, Apps &amp; Data"
        />
        <meta
          property="og:description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/50551946-307e-48ab-899a-950ab7a25dad/6b02e41a-da5a-475f-a28c-27c456397767?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Header
        textAbout={
          <Fragment>
            <span className="impressum-page-text10">About</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="impressum-page-text11">Contact</span>
          </Fragment>
        }
        textProjects={
          <Fragment>
            <span className="impressum-page-text12">Projects</span>
          </Fragment>
        }
        textServices={
          <Fragment>
            <span className="impressum-page-text13">Services</span>
          </Fragment>
        }
        textAboutMobile={
          <Fragment>
            <span className="impressum-page-text14">About</span>
          </Fragment>
        }
        textContactMobile={
          <Fragment>
            <span className="impressum-page-text15">Contact</span>
          </Fragment>
        }
        textProjectsMobile={
          <Fragment>
            <span className="impressum-page-text16">Projects</span>
          </Fragment>
        }
        textServicesMobile={
          <Fragment>
            <span className="impressum-page-text17">Services</span>
          </Fragment>
        }
      ></Header>
      <Impressum
        impressumTitle={
          <Fragment>
            <span className="impressum-page-text18">Impressum</span>
          </Fragment>
        }
        nameTitle={
          <Fragment>
            <span className="impressum-page-text19">Name:</span>
          </Fragment>
        }
        standortTitle={
          <Fragment>
            <span className="impressum-page-text20">
              Standort der Gewerbeberechtigung:
            </span>
          </Fragment>
        }
        linkPrivacyPolicy={
          <Fragment>
            <span className="impressum-page-text21">Privacy Policy</span>
          </Fragment>
        }
        mitgliedTitle={
          <Fragment>
            <span className="impressum-page-text22">
              Mitgliedschaften bei der Wirtschaftskammerorganisation:
            </span>
          </Fragment>
        }
        kontaktTitle={
          <Fragment>
            <span className="impressum-page-text23">Kontaktdaten:</span>
          </Fragment>
        }
        unternehmensgegenstandTitle={
          <Fragment>
            <span className="impressum-page-text24">
              Unternehmensgegenstand:
            </span>
          </Fragment>
        }
        rechtsvorschriftenTitle={
          <Fragment>
            <span className="impressum-page-text25">
              Anwendbare Rechtsvorschriften und Zugang dazu:
            </span>
          </Fragment>
        }
        aufsichtsbehoerdeTitle={
          <Fragment>
            <span className="impressum-page-text26">
              Aufsichtsbehörde/Gewerbebehörde:
            </span>
          </Fragment>
        }
        zurDatenschutzerklaerung={
          <Fragment>
            <span className="impressum-page-text27">
              Zur Datenschutzerklärung: 
            </span>
          </Fragment>
        }
        nameText={
          <Fragment>
            <span className="impressum-page-text28">Stefan Lacher</span>
          </Fragment>
        }
        zweckTitle={
          <Fragment>
            <span className="impressum-page-text29">Zweck der Webseite:</span>
          </Fragment>
        }
        standortText={
          <Fragment>
            <span className="impressum-page-text30">
              <span>Siehdichfürstraße 131</span>
              <br></br>
              <span>2231 Strasshof an der Nordbahn</span>
              <br></br>
              <span>Austria</span>
              <br></br>
            </span>
          </Fragment>
        }
        hinweisTitle={
          <Fragment>
            <span className="impressum-page-text37">
              Hinweis zur Datenschutzerklärung:
            </span>
          </Fragment>
        }
        unternehmensgegenstandText={
          <Fragment>
            <span className="impressum-page-text38">
              Dienstleistungen in der automatischen Datenverarbeitung und
              Informationstechnik
            </span>
          </Fragment>
        }
        kontaktText={
          <Fragment>
            <span className="impressum-page-text39">
              E-Mail: contact@stefanlacher.com
            </span>
          </Fragment>
        }
        mitgliedText={
          <Fragment>
            <span className="impressum-page-text40">
              Mitglied der Wirtschaftskammer Österreich (WKÖ), Wirtschaftskammer
              Niederösterreich (WKNÖ)
            </span>
          </Fragment>
        }
        rechtsvorschriftenText={
          <Fragment>
            <span className="impressum-page-text41">
              <span>Gewerbeordnung: www.ris.bka.gv.at</span>
              <br></br>
            </span>
          </Fragment>
        }
        aufsichtsbehoerdeText={
          <Fragment>
            <span className="impressum-page-text44">
              Bezirkshauptmannschaft Gänserndorf
            </span>
          </Fragment>
        }
        zweckText={
          <Fragment>
            <span className="impressum-page-text45">
              Information über angebotene IT-Dienstleistungen, insbesondere im
              Bereich Softwarelösungen, Entwicklung, Beratung und verwandte
              Tätigkeiten.
            </span>
          </Fragment>
        }
        hinweisText={
          <Fragment>
            <span className="impressum-page-text46">
              Informationen zum Datenschutz finden Sie in der
              Datenschutzerklärung.
            </span>
          </Fragment>
        }
      ></Impressum>
      <Footer
        textMade={
          <Fragment>
            <span className="impressum-page-text47">Made with</span>
          </Fragment>
        }
        textName={
          <Fragment>
            <span className="impressum-page-text48">Stefan Lacher</span>
          </Fragment>
        }
        textYear={
          <Fragment>
            <span className="impressum-page-text49">© 2025</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="impressum-page-text50">Contact</span>
          </Fragment>
        }
        textImpressum={
          <Fragment>
            <span className="impressum-page-text51">Impressum</span>
          </Fragment>
        }
        textPrivacyPolicy={
          <Fragment>
            <span className="impressum-page-text52">Privacy Policy</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default ImpressumPage
